import { iStore } from "../../store.model";

const emptyArray: any[] = [];

export const selectOrganizationLogo = (state: iStore) =>
  state.organizations.organization?.data.logo;

export const selectOrganizationPrimaryColor = (state: iStore) =>
  state.organizations.organization?.data.primaryColor;

export const selectOrganization = (state: iStore) =>
  state.organizations.organization;

export const selectOrganizationId = (state: iStore) =>
  state.organizations.organization?.id;

export const selectOrganizationDomain = (state: iStore) =>
  state.organizations.organization?.domain;

export const selectWhitelistedIPs = (state: iStore) =>
  state.organizations.organization?.data.whiteListedAccessIPs || emptyArray;

export const selectContactTags = (state: iStore) =>
  state.organizations.organization?.appData?.CRM?.contactTags || emptyArray;

export const selectSubscriptionDetails = (state: iStore) =>
  state.organizations.organization?.subscriptionDetails;

export const selectCRMCustomProperties = (state: iStore) =>
  state.organizations.organization?.appData?.CRM?.customCRMProperties ||
  emptyArray;

export const selectAccountStatus = (state: iStore) =>
  state.organizations.organization?.metaData.status;

export const selectShopifyBilling = (state: iStore) =>
  state.organizations.organization?.subscriptionDetails?.shopifyBilling
    ?.recurringApplicationChargeId;

export const selectAccountLimits = (state: iStore) =>
  state.organizations.organization?.metaData.limits;

export const selectAccountManager = (state: iStore) =>
  state.organizations.organization?.metaData.accountManager;

export const selectAccountBillingType = (state: iStore) =>
  state.organizations.organization?.metaData.customBilling;

export const selectAccountTrialEndDate = (state: iStore) =>
  state.organizations.organization?.metaData.trialEndDate;

const defaultFirstResponseConfig = {
  intervals: [30, 120, 300],
  labels: ["Fast", "Average", "Slow", "Super Slow"],
};

const defaultFirstResponseConfig2 = {
  intervals: [5 * 60, 9 * 60, 12 * 60],
  labels: ["Fast", "Average", "Slow", "Super Slow"],
};

export const selectFirstResponseIntervalConfig = (state: iStore) => {
  const currentOrganization = selectOrganizationId(state);
  if (currentOrganization === "0dd740") {
    return defaultFirstResponseConfig2;
  }
  return defaultFirstResponseConfig;
};

export const selectIndustry = (state: iStore) =>
  state.organizations.organization?.data?.industry;

export const selectDPAState = (state: iStore) =>
  state.organizations.organization?.data?.dpa;

export const selectIntegrationConfigs = (state: iStore) =>
  state.organizations.organization?.appData?.EXTERNAL_APPS;

export const selectIntegrationConfig_Stripe = (state: iStore) =>
  state.organizations.organization?.appData?.EXTERNAL_APPS?.stripe;

export const selectIntegrationConfig_Slack = (state: iStore) =>
  state.organizations.organization?.appData?.EXTERNAL_APPS?.slack;

export const selectIntegrationConfig_QuickBooks = (state: iStore) =>
  state.organizations.organization?.appData?.EXTERNAL_APPS?.quickbooks;

export const selectEnquiryTags = (state: iStore) =>
  state.organizations.organization?.appData?.TA_MASTER?.enquiryTags || emptyArray;


export const selectEnquirySources = (state: iStore) =>
  state.organizations.organization?.appData?.TA_MASTER?.enquirySources || emptyArray;

export const selectEnquiryRequestTypes = (state: iStore) =>
  state.organizations.organization?.appData?.TA_MASTER?.enquiryRequestTypes || emptyArray;


export const selectEnquiryBookingPeriods = (state: iStore) =>
  state.organizations.organization?.appData?.TA_MASTER?.enquiryBookingPeriods || emptyArray;

export const DEFAULT_PAYMENT_METHOD_TYPES = [
  "Bank direct debit",
  "Bank card",
  "Bank transfer",
  "Cash",
  "Cheque",
  "Other",
] as const;

export const selectPaymentMethodTypes = (state: iStore) => {
  const configured =
    state.organizations.organization?.appData?.TA_MASTER?.paymentMethodTypes;
  return configured && configured.length > 0
    ? configured
    : DEFAULT_PAYMENT_METHOD_TYPES;
};
